import { connect } from "react-redux";
import AdminLogin from "./AdminLogin.query";
import { mapStateToProps, mapDispatchToProps } from "./AdminLogin.state";

export default connect(mapStateToProps, mapDispatchToProps)(AdminLogin);
